// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3Yf0k","title":"BackImages_title__2ZNhC","images":"BackImages_images__s5E1M"};